import type { DecisionGraph } from "@imminently/decisively-core";

/**
 * The goal GoalMenu picks when it must have one and none is set: the first of the graph's sources (nodes nothing
 * depends on) that's marked a goal, or isn't a foreign key, identifier, inferred or meta attribute. Its path when
 * `instances` (falling back to its id), otherwise its id; undefined when there's no such node.
 */
export const defaultGoalId = (graph: DecisionGraph, instances: boolean): string | undefined => {
  for (const id of graph.ids()) {
    if (graph.predecessors(id).length > 0) continue;
    const isGoal = Boolean(graph.field(id, "goal")) || !(
      graph.field(id, "fk")
      || graph.field(id, "identifier")
      || graph.field(id, "inferred")
      || graph.field(id, "meta")
    );
    if (!isGoal) continue;
    const goalId = (instances ? (graph.field(id, "path") || graph.field(id, "id")) : graph.field(id, "id")) as string | undefined;
    if (goalId) return goalId;
  }
  return undefined;
};
